import { KalturaAssetReferenceType } from '../../enums';
import { requestPhoenix } from '../../network';

export type FetchAssetArgs = {
  assetReferenceType: KalturaAssetReferenceType;
  id: string;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/asset/action/get
 */
export function fetchAsset<T>({ assetReferenceType, id }: FetchAssetArgs) {
  return requestPhoenix<T>({
    path: '/asset/action/get',
    body: {
      assetReferenceType,
      id,
    },
  });
}
